var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBusinessFields = function SvgBusinessFields(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".business-fields_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 10.5h3.5a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-21a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1H7",
    className: "business-fields_svg__a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.782 12.547 8.54 13.959l1.414-4.243 8.132-8.131a2 2 0 0 1 2.828 2.828ZM19.5 5.827l-2.829-2.828M12.782 12.547 9.954 9.716",
    className: "business-fields_svg__a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.379 2.292a2 2 0 0 0-2.829 0l-2.121 2.121h-.707M8.54 13.959l-.707.707",
    className: "business-fields_svg__a"
  })));
};
export default SvgBusinessFields;